import { rtdb } from './config';
import { ref, onValue, set, serverTimestamp, onDisconnect } from 'firebase/database';
import { auth } from './auth';

export const initializeNetworkMonitoring = () => {
  const user = auth.currentUser;
  if (!user) return;

  const userStatusRef = ref(rtdb, `status/${user.uid}`);
  const connectedRef = ref(rtdb, '.info/connected');

  const updateOnlineStatus = async (isOnline: boolean) => {
    if (!user) return;

    try {
      await set(userStatusRef, {
        isOnline,
        lastSeen: serverTimestamp(),
      });
    } catch (error) {
      if (import.meta.env.DEV) {
        console.warn('[Network] Failed to update online status:', error);
      }
    }
  };

  // Monitor connection state
  const unsubscribe = onValue(connectedRef, (snapshot) => {
    if (snapshot.val() === true) {
      void updateOnlineStatus(true);

      // When user disconnects, update the database
      void onDisconnect(userStatusRef)
        .set({
          isOnline: false,
          lastSeen: serverTimestamp(),
        })
        .catch((error) => {
          if (import.meta.env.DEV) {
            console.warn('[Network] Failed to register onDisconnect:', error);
          }
        });
    }
  });

  // Monitor browser online/offline events
  const handleOnline = () => {
    void updateOnlineStatus(true);
  };
  const handleOffline = () => {
    void updateOnlineStatus(false);
  };
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  // Update status when window/tab is hidden/visible
  const handleVisibilityChange = () => {
    void updateOnlineStatus(document.visibilityState === 'visible');
  };
  document.addEventListener('visibilitychange', handleVisibilityChange);

  return () => {
    unsubscribe();
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};
